module.exports = __webpack_public_path__ + "img/img5.9a5ef129.jpg";